import { UsersError } from '@/lib/Errors';
import _axios from '@/plugins/axios';
export default {
	async getDataFrom3rdParty (patientId) {
		const response = await _axios.post('terra/authorizeterraforgettingdata', { patientId });
		if (response.data.resFlag) {
			return response.data.data.url;
		}
		throw new UsersError('No terra data!');
	},
	async eventHandler () {
		const response = await _axios.post('terra/eventhandler');
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('No event data!');
	},
	async getTerraUserMappingTable (locationId) {
		let response;
		if (locationId === undefined || locationId === null) {
			response = await _axios.get('terra/getterrausermappingtable');
		} else {
			response = await _axios.get('terra/getterrausermappingtable', { headers: { locationId } });
		}
		if (response.data.msg === 'No user mappings found.') {
			return [];
		}
		if (response.data.resFlag) {
			return response.data.data;
		}
		throw new UsersError('No user mapping data!');
	},
	async getECPUsersForTerraMappings () {
		const response = await _axios.get('terra/getecpusersforterramappings');
		if (response.data.resFlag) {
			return response.data.data;
		} else {
			return [];
		}
	},
	async setSendingDataFromTerraToECP (body) {
		if (body.patientId === null || body.patientId === undefined) {
			await _axios.put('terra/setsendingdatafromterratoecp', null, {
				headers: { enableSendingDataToECP: body.enableSendingDataToECP, locationId: body.locationId },
			});
		} else {
			await _axios.put('terra/setsendingdatafromterratoecp', null, {
				headers: {
					enableSendingDataToECP: body.enableSendingDataToECP,
					locationId: body.locationId,
					patientId: body.patientId,
				},
			});
		}
	},
	async setECPUserInpersonateId (body) {
		if (body.patientId === null || body.patientId === undefined) {
			await _axios.put('terra/setecpuserinpersonateid', null, {
				headers: { ecpUserInpersonateId: body.ecpUserInpersonateId, locationId: body.locationId },
			});
		} else {
			await _axios.put('terra/setecpuserinpersonateid', null, {
				headers: {
					ecpUserInpersonateId: body.ecpUserInpersonateId,
					locationId: body.locationId,
					patientId: body.patientId,
				},
			});
		}
	},
};
